module.exports = {
	searchProducts({ commit }, payload) {
		// param: {
		// 	part_family: Number,
		// 	options: {
		// 		key: String // attributes
		// 	},
		// 	type: String,
		// 	search: String,
		// 	include_hidden: Boolean
		// }

		return axios.get('/api/parts', { params: payload.params });
	},

	getProducts({ commit }) {
		return axios.get('/api/parts').then(({ data }) => {
			commit(
				'SET_VALUE',
				{
					name: 'products.products',
					value: data,
				},
				{ root: true }
			);

			return data;
		});
	},

	getProduct({ commit }, payload) {
		return axios.get(`/api/products/${payload}`);
	},

	getCategories({ commit }) {
		return axios.get('/api/categories').then(({ data }) => {
			commit(
				'SET_VALUE',
				{
					name: 'products.categories',
					value: data,
				},
				{ root: true }
			);

			return data;
		});
	},

	getAttributes({ commit }, payload) {
		// console.log(payload.params);

		return axios
			.get(`/api/categories/${payload.category}/attributes`, {
				params: payload.params,
			})
			.then(({ data }) => {
				let name = 'attributes'

				// if( !_.isEmpty(payload.params)) {
				// 	name = `enabled_${name}`;
				// } else {
					commit(
						'SET_VALUE',
						{
							name:  `products.enabled_${name}`,
							value: data,
						},
						{ root: true }
					);
				// }

				commit(
					'SET_VALUE',
					{
						name:  `products.${name}`,
						value: data,
					},
					{ root: true }
				);

				return data;
			});
	},
};
